import React from 'react';
import { AdSpotterWidget } from '../AdSpotterWidget';
import { AuthProvider } from './auth/AuthContext';

const WidgetPage = () => {
  return (
    <AuthProvider>
      <div className="w-full h-screen flex items-center justify-center">
        <AdSpotterWidget />
      </div>
    </AuthProvider>
  );
};

export default WidgetPage;